// views.app.settings.settings.user

export const USER = {
  title: 'Account Settings',
  description: 'Manage your personal details and settings.'
};
